import degree from './degree'
import homepage from './homepage'

const registerstudentpay = {
  path: 'registerstudentpay',
  component: resolve => require(['../../../components/pages/registerstudentpay'], resolve),
  redirect: 'registerstudentpay/homepage',
  children: [
    ...degree,
    homepage
  ]
}

export default registerstudentpay



// WEBPACK FOOTER //
// ./src/router/pages/registerstudentpay/index.js